<div class="flex justify-between flex-col h-full">
  <div class="text-ladder-black flex flex-col justify-center items-center h-full">
    <div *ngIf="verificationStatus === 'verifying'" class="flex flex-col items-center">
      <img src="assets/imgs/email-sended.svg" class="w-64" alt="Email Verifying Icon" />
      <h1 class="font-bold text-3xl mt-8">Verifying your Email...</h1>
      <p class="mt-2 text-base opacity-80">Please wait a moment.</p>
    </div>

    <div *ngIf="verificationStatus === 'success'" class="flex flex-col items-center">
      <img src="assets/imgs/email-sended.svg" class="w-64" alt="Email Confirmed Icon" />
      <h1 class="font-bold text-3xl text-green-600 mt-8">Email Confirmed!</h1>
      <p class="mt-2 text-base opacity-80">Your email has been successfully verified.</p>
      <p class="mt-4">You will be redirected shortly.</p>
    </div>

    <div *ngIf="verificationStatus === 'error'" class="flex flex-col items-center">
      <img src="assets/imgs/email-sended.svg" class="w-64" alt="Verification Error Icon" />
      <h1 class="font-bold text-3xl text-red-600 mt-8">Verification Error</h1>
      <p class="mt-2 text-base opacity-80">{{ errorMessage }}</p>
    </div>
  </div>
</div>
